import React, {useEffect, useState} from 'react'
import {Accordion, Button, Col, Form, Modal, Row, Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import i18next from 'i18next'
import {PopoverText, RichText} from 'src/components'
import {MultiSelect} from 'react-multi-select-component'
import {getRoleFlagList} from 'src/api/modules/master-data/master_2'
import {KTSVG} from 'src/_metronic/helpers'
import {HakAkses} from 'src/components/mikro/getHakAkses'
import dateformat from 'src/utils/dateformat'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import swal from 'sweetalert'
import {create, deleteFile, getFile} from 'src/api/modules/file'
import Skeleton from 'react-loading-skeleton'
import getCurrentFormattedDate from 'src/utils/Today'
import { InputFile } from 'src/app/components/InputFile'

interface PropsItem {
  attachmentType: any
  setAttachmentType: any
  subOrderId: any
  item: any
  show: boolean
  onCloseModal(): void
  onStoreAttachmentNewProduct(attachments: any[], index: number): void
}

export const AttachhmentModal: React.FC<PropsItem> = (props) => {
  const {t} = useTranslation()
  const hakAkses = HakAkses()
  const [btnLoadingA, setBtnLoadingA] = useState(false)
  const [loadingSkeleton, setLoadingSkeleton] = useState(false)
  const [files, setFiles] = useState({file: null})

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [fileBase64, setFileBase64] = useState<any>()
  const [roles, setRoles] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')

  const [fullRole, setFullRole] = useState<any[]>([])

  const ambilAttachment = async (id: any, type: any = null) => {
    if (id) {
      setLoadingSkeleton(true)
      if(type) props.setAttachmentType(type)
      await getFile(type || props.attachmentType, id, localStorage.getItem('credential')!).then((res) => {
        setAllFiles(res.data.data)
      })
      setLoadingSkeleton(false)
    }
  }

  const clearInputUpload = () => {
    const inputPrivate2 = document.getElementById('isPrivate2') as HTMLInputElement
    const input2 = document.getElementById('upload') as HTMLInputElement
    if (inputPrivate2 != null) inputPrivate2.checked = false
    if (input2 != null) input2.value = ''
  }

  const removeFileState = () => {
    setFiles({file: null})
    setFileBase64('')
    setNamaFile('')
    setDescription('')
    setDataType('')
    setIsPrivate(false)
    setRoles([])
  }

  const validasiFile3 = () => {
    if (fileBase64 == null || fileBase64 == '') return 'File'
    else if (description == '') return 'File Information'
    else return ''
  }

  const getBase64File3 = (file: any) => {
    var reader = new FileReader()
    setNamaFile(file.name)
    reader.readAsDataURL(file)
    reader.onload = function () {
      setFileBase64(reader.result)
    }
    reader.onerror = function (error) {
      alert('Error: ' + error)
    }
  }

  const getAllRoleList = async () => {
    const res = await getRoleFlagList()
    setFullRole(res.data.data)
  }

  const handleShowRoleName = (role: any) => {
    let temp: string = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  useEffect(() => {
    console.log("handle show")
    getAllRoleList()
    ambilAttachment(props.subOrderId, props.attachmentType)
  }, [props.subOrderId])

  const handleUpload = async () => {
    setBtnLoadingA(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (roles.length > 0) {
      roles.forEach((data: any) => {
        temparray.push(data.value)
      })
    }

    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', props.subOrderId)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    formdata.append('unique_number', props.item.order_sub_item_id)
    formdata.append('unique_flag', 'new_contract_osd')

    await create(props.attachmentType, formdata)
      .then((res: any) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setRoles([])
          setIsPrivate(false)
          setFiles({file: null})
        })
        ambilAttachment(props.subOrderId)
        clearInputUpload()
        removeFileState()
      })
      .catch((error: any) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoadingA(false)
      })
  }

  const handleUploadNewProduct = async () => {
    new Promise((resolve, reject) => {

      setBtnLoadingA(true)
      const checkvalidasi = validasiFile3()

      if (!checkvalidasi) {

        const new_attachment = {
          file_r: fileBase64,
          name: namaFile,
          description: description,
          file_type: "",
          roles: roles.map((role: any) => role.value),
          private: isPrivate
        }

        setAllFiles([... allFiles, new_attachment])
        props.onStoreAttachmentNewProduct([... allFiles, new_attachment], props.item?.index)

        clearInputUpload()
        removeFileState()

        setTimeout(() => resolve(true), 500)
    
       } else reject(checkvalidasi)

    }).then(() => {
      swal({
        title: `${t('document uploaded successfully')}`,
        icon: 'success',
      })
    }).catch((err: string) => {
      swal({
        title: t('isi') + err,
        icon: 'error',
      })
    }).finally(() => {
      setBtnLoadingA(false)
    });
    
  }

  function download_file(fileURL: any, fileName: any) {
    var save = document.createElement('a')
    save.href = fileURL
    save.target = '_blank'
    // var filename = fileURL.substring(fileURL.lastIndexOf('/') + 0)
    let temp = fileName.split('.')
    var filename = temp[0]
    // console.log(filename.slice(1, 20))
    // save.download = filename.slice(1, 20)
    save.download = filename
    if (
      navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
      navigator.userAgent.search('Chrome') < 0
    ) {
      document.location = save.href
    } else {
      var evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
      })
      save.dispatchEvent(evt)
      ;(window.URL || window.webkitURL).revokeObjectURL(save.href)
    }
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        if (props.item?.id) {
        await deleteFile(id)
          .then(() => {
            ambilAttachment(props.item?.order_sub_item_id || props.item?.id)
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
        } else {
          setAllFiles(allFiles.filter((item: any, idx) => idx != id))
          props.onStoreAttachmentNewProduct(allFiles.filter((item: any, idx) => idx != id), props.item?.index)
          swal({
            closeOnClickOutside: false,
            title: t('Dokumen Berhasil Dihapus'),
            icon: 'success',
          })
        }
      }
    })
  }

  return (
    <div>
      <Modal
        size='lg'
        show={props.show}
        onHide={() => {
          props.onCloseModal()
          setAllFiles([])
          clearInputUpload()
          removeFileState()
        }}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {props.item?.product_name
              ? (props.item.province ? props.item.province?.region_name : '') +
                (props.item.city ? ', ' + props.item.city?.city_name : '') +
                (props.item.province ? ' | ' : '') +
                props.item.product_name +
                (props.item.request_quantum ? ' | ' + props.item.request_quantum + ' Ton' : '')
              : t('File Box')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingSkeleton ? (
            <>
              <Col lg={6}>
                <Skeleton count={3} height={30} />
              </Col>
            </>
          ) : (
            <>
              <Row>
                <Col sm={6}>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('order-fileUnggah')}</h6>
                      </td>
                      <td className='w-75'>
                        <InputFile
                            setFileName={setNamaFile}
                            setFiles={(value: any) => {
                              if(props.item?.id){
                                setFiles(value)
                              }else{
                                setFileBase64(value)
                              }
                            }}
                            isBase64={props.item?.id ? false : true}
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('order-keterangan')}</h6>
                      </td>
                      <td className='w-75'>
                        <Form.Control
                          type='text'
                          placeholder={t('order-keterangan')}
                          onChange={(e: any) => setDescription(e.target.value)}
                          value={description}
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td>
                        <h6 className='me-11'>{t('Private')}</h6>
                      </td>
                      <td className='w-75 d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='isPrivate'
                          type='checkbox'
                          className='mt-5 mb-2'
                          onClick={() => {
                            setIsPrivate(!isPrivate)
                            setRoles([])
                          }}
                          id='isPrivate2'
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3' hidden={isPrivate ? false : true}>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('Akses Role')}</h6>
                      </td>
                      <td className='w-75' style={{maxWidth: '274px'}}>
                        <MultiSelect
                          key={isPrivate.toString()}
                          options={fullRole?.map((item: any) => {
                            return {label: item.label, value: item.value}
                          })}
                          value={roles}
                          onChange={(e: any) => setRoles(e)}
                          labelledBy='Select'
                        />
                      </td>
                    </tr>
                  </table>
                  <div className='d-flex justify-content-end'>
                    <Button
                      variant='primary'
                      className='w-100'
                      onClick={() => props.item?.id ? handleUpload() : handleUploadNewProduct()}
                      disabled={btnLoadingA}
                    >
                      {btnLoadingA ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        t('order-kirim')
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
              <div className='table-responsive mt-4 bdr'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {allFiles.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.description}</label>
                        </td>
                        <td className='text-center'>
                          <label>{props.item?.id ? dateformat(data.updated_at) : dateformat(getCurrentFormattedDate())}</label>
                        </td>
                        {/* <td className='text-center'>
                          <label>
                            {localStorage.getItem('cust-code') !== 'null'
                              ? localStorage.getItem('cust-code')
                              : localStorage.getItem('user_code')}
                          </label>
                        </td> */}
                        <td className='text-center'>
                          {data.user?.customer_code == null ? (
                            <label>{data.user?.name || localStorage.getItem('username')}</label>
                          ) : (
                            <label>{data.user?.customer?.name || localStorage.getItem('username')}</label>
                          )}
                        </td>
                        <td className='text-center'>
                          {data.private ? (
                            data.roles.length > 0 ? (
                              <PopoverText
                                content={handleShowRoleName(data.roles)}
                                index={_index}
                                className='desc-slice'
                              />
                            ) : (
                              'Private'
                            )
                          ) : (
                            'Public'
                          )}
                        </td>
                        <td className='text-center'>
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('unduh')}
                            onClick={() =>
                                props.item?.id ? window.open(
                                  data.file_path + `&token=${localStorage.getItem('token')}`
                              ) : download_file(data.file_r, data.name)
                            }
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrow-down-square-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                          {(hakAkses?.attachment_delete || CheckSameIDAttachment(data.user_role_flag) || !props.item?.id) && (
                            <button
                              onClick={() => {
                                deleteAttachment(data.id || _index)
                              }}
                              className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}
